import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { isPassengerNameModified } from './helper';
import { PassengerNameProps } from './index.types';

function PassengerName({ data }: PassengerNameProps) {
    const { title, firstName, lastName, updatedTitle, updatedFirstName, updatedLastName } = data;

    if (!isPassengerNameModified(data)) {
        return <Typography variant='body-md'>{`${title} ${firstName} ${lastName}`}</Typography>;
    }

    return (
        <div className='flex flex-col'>
            <Typography variant='body-md'>{`${updatedTitle} ${updatedFirstName} ${updatedLastName}`}</Typography>
            <div>
                <Typography className={clsx('inline text-neutral-600', title !== updatedTitle && 'line-through')}>
                    {title}
                </Typography>{' '}
                <Typography
                    className={clsx('inline text-neutral-600', firstName !== updatedFirstName && 'line-through')}
                >
                    {firstName}
                </Typography>{' '}
                <Typography className={clsx('inline text-neutral-600', lastName !== updatedLastName && 'line-through')}>
                    {lastName}
                </Typography>
            </div>
        </div>
    );
}

export default PassengerName;
